function hcDebounce(func, wait) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func.apply(context, args);
		}, wait);
	};
}

const hcFocusableElements = (container) => {
  return Array.from(
    container.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"], [role="button"]')
  )
  .filter(element => element.checkVisibility ? element.checkVisibility() : true );
}

const hcTrapFocus = (container) => {
  const KEYCODE_TAB = 9;
  const firstFocusableEl = hcFocusableElements(container)[0];
  firstFocusableEl.focus();

  container.keydownlistener = function(e) {
    const focusableElements = hcFocusableElements(container);

    if(e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
      if(e.shiftKey) { // shift + tab back
        if (document.activeElement == focusableElements[0] || !focusableElements.includes(document.activeElement)) {
          focusableElements[focusableElements.length - 1].focus();
          e.preventDefault();
        }
      } else { // tab forward
        if (document.activeElement == focusableElements[focusableElements.length - 1] || !focusableElements.includes(document.activeElement)) {
          focusableElements[0].focus();
          e.preventDefault();
        }
      }
    }
  };

  document.addEventListener('keydown', container.keydownlistener);
}

const hcCancelTrapFocus = (container) => {
  document.removeEventListener('keydown', container.keydownlistener);
}

const hcPriceFormatter = new Intl.NumberFormat("de-DE", {style: 'currency', currency: Shopify.currency.active});
const hcDOMParser = new DOMParser();
const hcAriaLive = document.getElementById('theme-aria-live');

function hcToggleDisabled(el,disable,disableClass){
	if(disable){
		if(disableClass){
			el.classList.add(disableClass);
		}
		el.setAttribute('disabled','true');
		el.setAttribute('tabindex','-1');
	} else {
		if(disableClass){
			el.classList.remove(disableClass);
		}
		el.removeAttribute('disabled');
		el.removeAttribute('tabindex');
	}
}


(function () {

	// Lazy load swiper
	let swipers = document.querySelectorAll("[data-swiper-init]");

	function addSwiper(el) {
		if (document.getElementById("swiper-js") == null) {
			let script = document.createElement("script");
			script.setAttribute("src", window.theme.assets.swiperJS);
			script.id = "swiper-js";
			document.head.appendChild(script);
			let styles = document.createElement("link");
			styles.setAttribute("href", window.theme.assets.swiperCSS);
			styles.setAttribute("rel", "stylesheet");
			document.head.appendChild(styles);
		}
		let timeout = setInterval(function () {
			if (typeof Swiper != "undefined") {
				clearInterval(timeout);
				initSwiper(el);
			}
		}, 100);
	}

	function initSwiper(el) {
		var optionsKey = el.dataset.swiperInit;
		if (!optionsKey) {
			return;
		}
		var options = window.swiperOptions[optionsKey];
		if (!options) {
			return;
		}
		var swiper = new Swiper(el, options);
		return swiper;
	}

	var swiperHandler = function (entries, observer) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var el = entry.target;
			swiperObserver.unobserve(el);
			addSwiper(el);
		});
	};
	var swiperObserver = new IntersectionObserver(swiperHandler, {
		rootMargin: "400px 0px 400px 0px",
	});
	swipers.forEach(function (el) {
		swiperObserver.observe(el);
	});

	// Lazy load background images
	var bgHandler = function (entries, observer) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var el = entry.target;
			bgObserver.unobserve(el);
			el.classList.remove("lazy-bg");
		});
	};
	var bgObserver = new IntersectionObserver(bgHandler, {
		rootMargin: "400px 0px 400px 0px",
	});
	var lazyBGs = document.querySelectorAll(".lazy-bg");
	lazyBGs.forEach(function (el) {
		bgObserver.observe(el);
	});

	if (Shopify.designMode) {
		window.addEventListener("shopify:section:load", function (e) {
			var editorLazyBGs = document.querySelectorAll(".lazy-bg");
			editorLazyBGs.forEach(function (el) {
				el.classList.remove("lazy-bg");
			});
		});
	}

	// Lazy load iframes
	var iframeHandler = function (entries, observer) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var el = entry.target;
			iframeObserver.unobserve(el);
			el.setAttribute("src", el.dataset.src);
		});
	};
	var iframeObserver = new IntersectionObserver(iframeHandler, {
		rootMargin: "400px 0px 400px 0px",
	});
	var lazyIframes = document.querySelectorAll(".lazy-iframe");
	lazyIframes.forEach(function (el) {
		iframeObserver.observe(el);
	});

	if (Shopify.designMode) {
		window.addEventListener("shopify:section:load", function (e) {
			var editorLazyIframes = document.querySelectorAll(".lazy-iframe");
			editorLazyIframes.forEach(function (el) {
				el.setAttribute("src", el.dataset.src);
			});
		});
	}

	// Lazy load videos
	var videos = document.querySelectorAll(".html-video");

	var videoAddHandler = function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			var el = entry.target;
			addVideo(el);
			videoAddObserver.unobserve(el);
		});
	};
	var videoAddObserver = new IntersectionObserver(videoAddHandler, {
		rootMargin: "400px 0px 400px 0px",
	});
	videos.forEach((el) => {
		videoAddObserver.observe(el);
	});
	function addVideo(el,play) {
		var sources = el.querySelectorAll("source");
		sources.forEach((source) => {
			source.src = source.dataset.src;
		});
		el.load();
		if (el.autoplay || play) {
			el.play();
		}
  }

  var playButtons = document.querySelectorAll('.play-video');
  playButtons.forEach(function(playButton) {
    playButton.addEventListener('click', function() {
      var video = this.parentElement.querySelector('video');
      var videoImg = this.parentElement.querySelector('img');
      if (video) {
        addVideo(video,true);
        this.classList.add('hide');
        if (videoImg) {
          videoImg.classList.add('hide');
        }
      }
    });
  });
})();

function hcScrollToElement(n, o) {
	var i,
		e = window.pageYOffset,
		t = n - e;
	window.requestAnimationFrame(function n(a) {
		i || (i = a);
		var r = a - i,
			w = Math.min(r / o, 1);
		window.scrollTo(0, e + t * w), r < o && window.requestAnimationFrame(n);
	});
}

function hcAnimateAnchor(target) {
	if (target == "#") {
		var targetEl = document.body;
	} else {
		var targetEl = document.getElementById(target.replace("#", ""));
	}
	if (targetEl && targetEl.style.display != "none") {
		var headerHeight = document.getElementById('theme-header').offsetHeight;
		var animateTo = window.pageYOffset + targetEl.getBoundingClientRect().top - headerHeight;
		hcScrollToElement(animateTo, 500);
	}
}

function hcFetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

// Page Loaded
window.addEventListener("DOMContentLoaded", () => {

	document.querySelectorAll(".animate-anchor").forEach((anchor) => {
		anchor.addEventListener("click", (e) => {
			e.preventDefault();
			hcAnimateAnchor(anchor.getAttribute("href"));
		});
	});

});


// Custom Elements
class ThemeHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.hamburger = document.getElementById('header-hamburger');
		this.mainMenu = document.getElementById('header-menu');
		this.mobileClose = document.querySelector('.header-menu__close');
		this.menuItemsWithSub = document.querySelectorAll('.main-menu__item--sub');
		this.subMenus = document.querySelectorAll('.main-menu__sub');
		this.subMenuArrows = document.querySelectorAll('.main-menu__arrow');
		this.hamburger.addEventListener('click', this.openMenu.bind(this));
		this.mobileClose.addEventListener('click', this.closeMenu.bind(this));
		this.menuItemsWithSub.forEach((li) => {
			li.addEventListener('mouseenter', this.toggleSubMenu.bind(this));
			li.addEventListener('mouseleave', this.toggleSubMenu.bind(this));
		});
		this.subMenus.forEach((menu) => {
			menu.addEventListener('focusout', this.toggleSubMenu.bind(this));
		});
		this.subMenuArrows.forEach((btn) => {
			btn.addEventListener('click', this.toggleSubMenu.bind(this));
		});
		window.addEventListener('scroll',(e) => {
			if(window.scrollY > 4) {
				document.body.classList.add('page-scrolled');
			} else {
				document.body.classList.remove('page-scrolled');
			}
		});
	}

	openMenu(){
		this.mainMenu.classList.add('active');
		this.hamburger.setAttribute('aria-expanded','true');
		hcTrapFocus(this.mainMenu);
	}

	closeMenu() {
		this.mainMenu.classList.remove('active');
		hcCancelTrapFocus(this.mainMenu);
		this.hamburger.setAttribute('aria-expanded','false');
		this.hamburger.focus();
	}

	toggleSubMenu(e){
		var self = this;
		let menuItem = (e.target.classList.contains('main-menu__item') ? e.target : e.target.closest('.main-menu__item'));
		if(!menuItem){return}
		var expanded = false;
		const btn = menuItem.querySelector('button.main-menu__arrow');
		const subMenu = document.getElementById(btn.getAttribute('aria-controls'));
		if(e.type.includes('mouse')){
			if(window.matchMedia('(max-width: 1023px)').matches){return}
			expanded = e.type == 'mouseleave';
		} else if(e.type == 'focusout'){
			setTimeout(function(){
				if(e.target.closest('.main-menu__sub') && !document.activeElement.closest('.main-menu__sub')){
					self.closeSubMenu(subMenu,btn);
				}
			},50);
			return;
		} else {
			expanded = btn.getAttribute('aria-expanded') == 'true';
		}
		if(!expanded){
			subMenu.classList.add('active');
		} else {
			subMenu.classList.remove('active');
		}
		btn.setAttribute('aria-expanded',!expanded);
	}

	closeSubMenu(subMenu,btn){
		subMenu.classList.remove('active');
		btn.setAttribute('aria-expanded','false');
	}
}

customElements.define('theme-header', ThemeHeader);

class ThemeFooter extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.menuButtons = document.querySelectorAll('.footer-menu__button');
		this.menuButtons.forEach((btn) => {
			btn.addEventListener('click', this.toggleMenu.bind(this));
		});
	}

	toggleMenu(e){
		const btn = e.target.nodeName == 'BUTTON' ? e.target : e.target.closest('button');
		const menu = document.getElementById(btn.getAttribute('aria-controls'));
		if(!menu){return}
		const expanded = btn.getAttribute('aria-expanded') == 'true';

		if(!expanded){
			menu.classList.add('active');
		} else {
			menu.classList.remove('active');
		}
		btn.setAttribute('aria-expanded',!expanded);
	}

}

customElements.define('theme-footer', ThemeFooter);


class hcModalButton extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this._modal = document.querySelector(`#${this.dataset.modalId}`);
		this.addEventListener('click', this.toggleModal.bind(this));
	}

	toggleModal() {
		let is_hidden = this._modal.classList.contains('hide');
		if(is_hidden) {
			this._modal.classList.remove('hide');
			hcTrapFocus(this._modal);
			return;
		}
		this._modal.classList.add('hide');
	}
}

customElements.define('hc-modal-button', hcModalButton);

class hcModal extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this._close_buttons = this.querySelectorAll(".js-close");
		if(this._close_buttons) {
			var self = this;
			this._close_buttons.forEach(function(btn) {
				btn.addEventListener('click', self.closeModal.bind(self));
			});
		}
		this.addEventListener('click', (event) => { this.clickOutside(event) });
	}

	clickOutside(event) {
		if(event.target == this) {
			this.closeModal();
		}
	}

	closeModal() {
		this.classList.add('hide');
		hcCancelTrapFocus(this);
	}
}

customElements.define('hc-modal', hcModal);

// Footer Newsletter Form
document.addEventListener("DOMContentLoaded", function() {
	const newsletterForm = document.getElementById("footer-newsletter-form");

	if (!newsletterForm) return;
	const emailInput = document.getElementById("footer-newsletter-email");
	const newsletterError = document.getElementById("newsletter-error");
	const submitButton = newsletterForm.querySelector('button[type="submit"]');

	function isValidEmail(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	emailInput.addEventListener("blur", function() {
		const emailValue = emailInput.value.trim();

		if (!emailValue || !isValidEmail(emailValue)) {
			newsletterError.style.display = 'block';
			submitButton.disabled = true;
			emailInput.classList.add('input--error');
		} else {
			newsletterError.style.display = 'none';
			submitButton.disabled = false;
			emailInput.classList.remove('input--error');
		}
	});

	newsletterForm.addEventListener("submit", function(event) {
		event.preventDefault();

		const formData = new FormData(newsletterForm);
		const actionUrl = newsletterForm.getAttribute('action');
		const redirectInput = newsletterForm.querySelector('input[name="redirect"]');
		const redirectUrl = redirectInput ? redirectInput.value : null;
		const successMessage = document.getElementById("newsletter-success");

		fetch(actionUrl, {
			method: 'POST',
			body: formData,
			mode: 'no-cors'
		})
		.then(response => {
			if (redirectUrl) {
				window.location.href = redirectUrl;
			} else {
				newsletterForm.style.display = 'none';
				successMessage.style.display = 'block';
				successMessage.setAttribute('tabindex','0');
				successMessage.focus();
			}
		})
		.catch(error => {
			console.error('Error submitting form:', error);
		});
	});
});